/**
 * Created by PhpStorm
 * Author: Mikhail Zheludkov <mzheludkov@clubautomation.com>
 * Date: 06/28/2016
 * Time: 1:56 PM
 */

(function($) {
    $.widget("ca.caDateRangePicker", {
        _create : function() {
            this.element.datepicker();
        }
    });
})(jQuery);
